import { render } from "./ChinaMap.vue?vue&type=template&id=71680cd2"
import script from "./ChinaMap.vue?vue&type=script&lang=js"
export * from "./ChinaMap.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/index/components/ChinaMap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71680cd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71680cd2', __exports__)) {
    console.log('reload')
    api.reload('71680cd2', __exports__)
  }
  
  module.hot.accept("./ChinaMap.vue?vue&type=template&id=71680cd2", () => {
    console.log('re-render')
    api.rerender('71680cd2', render)
  })

}


export default __exports__